<div class="mb-4 question-container">
  <div class="question-header">Pregunta</div>
  <form>
    <fieldset *ngIf="data.test">
      <legend class="quiz-statement">{{data.question}}</legend>
      <label class="answer {{answer.status??''}}" *ngFor="let answer of data.answers">
        <input type="checkbox" name="answer{{answer.id}}"
        [(ngModel)]="answer.checked" [disabled]="data.locked"/>
        {{answer.text}}
      </label>
    </fieldset>
  </form>
  <p *ngIf="data.sent" class="{{data.correctionMessageClass}}">
    {{data.correctionMessage}}
  </p>
  <quill-editor [sanitize]="true" *ngIf="!data.test" [(ngModel)]="data.txtAnswer" [modules]="modules"></quill-editor>
  <button *ngIf="!data.locked" class="btn btn-levelab" (click)="saveAnswer()" [disabled]="data.locked || !isAnyAnswerChecked()">
    Enviar respuesta
  </button>
</div>
